import { render } from "./CanvasFullScreen.vue?vue&type=template&id=04c7e192&scoped=true"
import script from "./CanvasFullScreen.vue?vue&type=script&lang=js"
export * from "./CanvasFullScreen.vue?vue&type=script&lang=js"

import "./CanvasFullScreen.vue?vue&type=style&index=0&id=04c7e192&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04c7e192"]])

export default __exports__